
<div class="pe-footer" [ngStyle]="{backgroundColor:footer.bgColor}">
  <ng-content></ng-content>

  <div class="pe-f-container" [ngStyle]="{
         paddingLeft:footer.paddingOnSides + 'px',
         paddingRight:footer.paddingOnSides  + 'px',
         maxWidth:layoutSetting.maxWidth + 'px'}">

    <div class="row">
      <div class="col-sm-6">
        <div class="">
          <div class="pe-f-l-title">QUICK LINKS</div>
          <ul class="pe-f-l-links" [ngStyle]="{color:footer.colorLink}" *ngIf="!viewOnly">
            <li><a>Home</a></li>
            <!--<li><a>About Us</a></li>-->
            <li><a>Privacy & Policy</a></li>
            <li><a>Terms Of Use</a></li>
          </ul>
          <ul class="pe-f-l-links" [ngStyle]="{color:footer.colorLink}" *ngIf="viewOnly">
            <li><a [routerLink]="[ '/', storeUrl ]">Home</a></li>
            <!--<li><a target="_blank" [routerLink]="[ 'about' ]" >About Us</a></li>-->
            <li><a [routerLink]="[ 'privacy-policy' ]">Privacy & Policy</a></li>
            <li><a [routerLink]="[ 'terms-of-use' ]">Terms Of Use</a></li>
          </ul>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="pe-f-links-social" *ngIf="displaySocialLink()">
          <div class="pe-f-l-title">FOLLOW US </div>
          <ul class="pe-f-l-links" [ngStyle]="{color:footer.colorLink}" *ngIf="!viewOnly">
            <li *ngIf="linksSocial.FacebookUrl!=''"><a> <span class="fa fa-facebook"></span> Facebook Page</a></li>
            <li *ngIf="linksSocial.TwitterUrl!=''"><a> <span class="fa fa-twitter"></span> Twitter Page</a></li>
            <li *ngIf="linksSocial.InstagramUrl!=''"><a> <span class="fa fa-instagram"></span>  Instagram</a></li>
            <li *ngIf="linksSocial.YouTubeUrl!=''"><a> <span class="fa fa-youtube"></span> Youtube</a></li>
          </ul>
          <ul class="pe-f-l-links" [ngStyle]="{color:footer.colorLink}" *ngIf="viewOnly">
            <li *ngIf="linksSocial.FacebookUrl!=''"><a [href]="linksSocial.FacebookUrl"> <span class="fa fa-facebook"></span> Facebook Page</a></li>
            <li *ngIf="linksSocial.TwitterUrl!=''"><a [href]="linksSocial.TwitterUrl"> <span class="fa fa-twitter"></span> Twitter Page</a></li>
            <li *ngIf="linksSocial.InstagramUrl!=''"><a [href]="linksSocial.InstagramUrl"> <span class="fa fa-instagram"></span>  Instagram</a></li>
            <li *ngIf="linksSocial.YouTubeUrl!=''"><a [href]="linksSocial.YouTubeUrl"> <span class="fa fa-youtube"></span> Youtube</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="pe-footer-bottom">Copyright ©  MerchLoop &bull; All Rights Reserved</div>
</div>
